import IBAN from 'iban';
import { validateCreditorID } from 'sepa';
import { ibanPrefixDe } from './rules/ibanPrefixless';
import validator from 'email-validator';

export const ValidationRules = {
  bic: /^([a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)$/,
  blz: /^[1-9][0-9]{7}$/,
  cid: validateCreditorID,
  fax: /^[0-9\-\+\s\(\)\/\\]*$/,
  iban: IBAN.isValid.bind(IBAN),
  ibanPrefixDe,
  postcode: /^[0-9]{5}$/,
  tel: /^[0-9\-\+\s\(\)\/\\]*$/,
  email: validator.validate
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-form-validation/src/validationRules.constants.js